import styled from 'styled-components';
import { withModifiers } from 'utils/styles';
import { ui } from 'styles/settings/color';
import Skeleton from '@material-ui/lab/Skeleton';

export const Content = styled.div`
  background: ${ui.backgroundGray};
  margin-left: ${({ widthOffset }) => widthOffset / 2 + 'px'};
  margin-top: ${({ heightOffset }) => heightOffset / 2 + 'px'};
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  ${withModifiers('isLoading')`
    opacity: 1;
  `};
  ${withModifiers('shouldHide')`
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
     opacity: 0;
     position:absolute;
     top: -54444444;
     left: -54444444;
  `}
`;

export const Loader = styled(Skeleton)`
  background-color: rgba(0, 0, 0, 0) !important;
  &:after {
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent
    ) !important;
  }
  opacity: 1 !important;
`;
